import React from "react";

import { cn } from "../../utils/utils";

const TextArea = (props) => {
  const { register, name, label, type, onchange, errors, placeholder, className, disabled } = props;

  return (
    <div className={cn(" col-span-2 xl:col-span-1 flex flex-col gap-2", className)}>
      <label htmlFor="">{label}</label>
      <textarea
        className="min-h-[52px] max-h-[82px] no-scrollbar p-4 my-2 outline-none rounded-v-md  w-full border-2 border-neutral-30 disabled:bg-neutral-10 disabled:border-none"
        {...register(name, { required: true })}
        name={name}
        type={type}
        disabled={disabled}
        onKeyUp={onchange}
        placeholder={placeholder}
        onWheel={(e) => e.target.blur()}
      />
      {errors?.message && <span className="text-red-500 text-sm">{errors?.message}</span>}
    </div>
  );
};

export default TextArea;
